
const icons = {
	TEXT:        'icon-minus',
	TEXT_AREA:   'icon-paragraph-left',
	CHECKBOX:    'icon-checkbox-checked',
	RADIO:       'icon-radio-checked',
	DROP_DOWN:   'icon-dropdown',
	STAR_RATING: 'icon-star-full',
};

const conditionsText = {
	'gt':      'CONDITION_GREATER_THAN',
	'lt':      'CONDITION_LOWER_THAN',
	'eq-prev': 'CONDITION_EQUAL_PREVIOUS',
	'eq':      'CONDITION_EQUAL',
	'no':      'CONDITION_NO',
};

export default class SurveyFormController {

	constructor (survey, Survey, $state, $filter, $timeout) {
		this.Survey = Survey;
		this.$state = $state;
		this.survey = survey;
		this.translate = $filter('translate');
		this.$timeout = $timeout;

		startAutoScroll();
	}

	back () {
		this.$state.go('surveysPage');
	}

	submit () {
		this.Survey.updateQuestions(
			this.survey.id,
			this.survey.elements.map(e => ({
				id:             e.id,
				text:           e.text,
				type:           e.type,
				options:        e.options.map(o => o.text),
				isChild:        e.isChild,
				condition:      e.condition,
				conditionValue: e.conditionValue
			}))
		).then(this.back.bind(this));
	}

	swapArray (arr, indexFrom, indexTo) {
		var tmp = arr[indexTo];
		arr[indexTo] = arr[indexFrom];
		arr[indexFrom] = tmp;
	}

	getIcon (questionType) {
		return icons[questionType];
	}

	getQuestionClass (question) {
		return question.isChild ? 'survey-form-page__question--child' : '';
	}



	/*
	 * Questions
	 */
	addQuestion (questionType, location) {
		var question = {
			type: questionType,
			text: '',
			options: [],
		};
		this.addOption(question);
		if (location === 'top') {
			this.survey.elements.unshift(question);
		} else if (location === 'bottom') {
			this.survey.elements.push(question);
		}
	}

	removeQuestion (question) {
		swal({
			title: this.translate('ARE_YOU_SURE'),
			text: `${this.translate('QUESTION_DELETE_QUESTION')} "${question.text}"`,
			type: 'warning',
			showCancelButton: true
		}, confirm => {
			if (confirm) {
				this.$timeout(_ =>
					this.survey.elements = this.survey.elements.filter(q => q !== question)
				);
			}
		});
	}

	swapQuestions (indexFrom, indexTo) {
		this.swapArray(
			this.survey.elements,
			indexFrom,
			indexTo
		);
		this.survey.elements[0].isChild = false;
		this.setCondition(this.survey.elements[0], 'no');
	}

	toggleChildFlag (question) {
		question.isChild = !question.isChild;
		if (!question.isChild) {
			this.setCondition(question, 'no');
		}
	}


	/*
	 * Conditions
	 */
	isNoCondition (question) {
		return this.getConditionText(question) == 'CONDITION_NO';
	}

	getConditionText (question) {
		return conditionsText[question.condition] || conditionsText.no;
	}

	setCondition (question, condition) {
		question.condition = condition;
		if (condition == 'no') {
			question.conditionValue = '';
		}
	}


	/*
	 * Options
	 */
	hasOption (questionType) {
		return questionType === 'DROP_DOWN' ||
		       questionType === 'RADIO' ||
		       questionType === 'CHECKBOX';
	}

	addOption (question) {
		if (this.hasOption(question.type)) {
			question.options.push({ text: '' });
		}
	}

	removeOption (question, option) {
		if (this.hasOption(question.type)) {
			question.options = question.options.filter(o => o !== option);
		}
	}

	swapOptions (question, indexFrom, indexTo) {
		this.swapArray(
			question.options,
			indexFrom,
			indexTo
		);
	}

}

SurveyFormController.$inject = ['survey', 'Survey', '$state', '$filter', '$timeout'];



/*
 * Helpers
 */
function startAutoScroll () {
	setTimeout(function () {
		var $el = document.querySelector('.menu-layout__content');
		var end = $el.scrollHeight - $el.clientHeight;
		var startTime = Date.now();
		var duration = 1000;

		var interval = setInterval(function () {
			var position = Math.min(1, (Date.now() - startTime) / duration);
			$el.scrollTop = easeInOutCubic(position) * end;

			if (position >= 1) {
				clearInterval(interval);
			}
		}, 1000/60); // 60fps
	}, 100);
}

function easeInOutCubic (t) {
	return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1;
}



// WEBPACK FOOTER //
// ./src/page/surveyForm/surveyForm.controller.js